import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696b35501beda800145232b8/weskill_academy/src/app/course-catalog/components/CourseCatalogInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696b35501beda800145232b8/weskill_academy/src/components/common/Header.tsx");
